import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';


class Dashboard extends Component {

    componentDidMount() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        } else {
            this.props.history.push("/zgloszenia")
        }
    }

    componentDidUpdate() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        }
    }

    render() {
        return (
            <div></div>
        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated
    }
}

export default withRouter(connect(mapStateToProps)(Dashboard))



// WEBPACK FOOTER //
// ./src/components/routes/Dashboard.js